import React from 'react';
import { Button } from '../buttons/button';
import { SyncStatusIcon, PendingFormIcon } from '../Icons/svgIcons';

const SyncCard = ({ title, count, onSyncNow, onViewForms }) => {
  const isDisabled = count === 0;

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 p-4 flex flex-col justify-between h-full min-h-[130px] shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5">
      <div className="flex items-start justify-between mb-3">
        <div className="flex flex-col gap-1">
          <span className="text-gray-500 text-[12px] font-bold uppercase tracking-wider">{title}</span>
          <div className="flex items-baseline gap-2">
            <span className="text-gray-900 text-2xl font-bold tracking-tight">{count}</span>
            <span className="text-gray-500 text-xs font-medium">pending items</span>
          </div>
        </div>
        <div className="w-9 h-9 rounded-lg icon-bg-theme flex items-center justify-center flex-shrink-0">
          <SyncStatusIcon className="w-5 h-5 icon-theme" />
        </div>
      </div>

      <div className="mt-auto pt-3 border-t border-gray-50 grid grid-cols-2 gap-2">
        <Button 
          onClick={onSyncNow} 
          disabled={isDisabled} 
          variant="primary" 
          size="small"
        >
          <SyncStatusIcon className="w-5 h-5 mr-1.5 text-white" />
          Sync Now
        </Button>
        <Button 
          onClick={onViewForms} 
          disabled={isDisabled} 
          variant="secondary" 
          size="small" 
          icon={<PendingFormIcon className="w-5 h-5" />}
        >
          View All
        </Button>
      </div>
    </div>
  );
};

export default SyncCard;